<!--
 * @Descripttion: 首页
 * @FilePath: /mall-wap-vue/src/views/home/index.vue
 * @Author: 张兴业
 * @Date: 2020-09-24 15:37:31
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2020-12-25 17:08:46
-->
<template>
  <!-- 隐藏内容都有用，一期不做，之后要用，勿删 -->
  <div class="home">
    <!-- 搜索 -->
    <!-- <div :style="bgStyle" class="bra_search" @click="goSearch">
      <div :style="opacityStyle" class="input_s clearfix">
        <img
          src="@/assets/common/search@2x.png"
          alt="select"
          class="search_img left"
        />
        <div :style="opacityName" class="search_name left">牛奶中的爱马仕</div>
      </div>
    </div> -->
    <!-- 轮播图 -->
    <!-- <div class="swiper_list">
      <swiper />
    </div> -->
    <!-- 品牌 -->
    <!-- <div class="brand_home">
      <brand />
    </div> -->
    <!-- 推荐分类 -->
    <!-- <division /> -->
    <!-- 资讯 -->
    <!-- <div class="ver_swiper clearfix" ref="productDet">
      <img src="@/assets/home/news@2x.png" alt="" class="news_title left" />
      <vertical-swiper class="left" />
      <img
        src="@/assets/common/icon_right_go@2x.png"
        alt="go"
        class="icon_right right"
      />
    </div> -->
    <!-- 分类商品 -->
    <!-- <div v-for="(i, index) in 2" :key="index">
      <home-middle-product />
    </div> -->
    <!-- 分类大图 -->
    <!-- <div class="product_bottom">
      <img src="@/assets/mooc/home3.png" alt="" />
    </div> -->
    <!-- 店铺信息 -->
    <store-det
      :clickIndex="clickIndex"
      @goSearch="goSearch"
      @clickTab="clickTab"
    />
    <!-- 清单名称 -->
    <div v-if="retailHomepage && retailHomepage.length > 0">
      <list-title
        id="theme"
        title="主题清单"
        :titleImg="require('@/assets/home/title1@2x.png')"
      />
      <!-- 清单列表 -->
      <theme-list @goMore="goMore" @showPoster="showPosters" />
    </div>
    <div v-if="homeProductList.rows && homeProductList.rows.length > 0">
      <!-- 全部商品 -->
      <list-title
        id="all"
        title="全部商品"
        :titleImg="require('@/assets/home/title2@2x.png')"
      />
      <!-- 底部商品 -->
      <div class="tar_product">
        <!-- <van-sticky :offset-top="32">
        <home-switch-bar />
      </van-sticky> -->
        <!--分类商品  -->
        <!-- <category-img /> -->
        <!-- 底部商品 -->
        <recommend
          :productCon="homeProductList"
          :loadings="loadings"
          @onRefresh="onRefresh"
          @onLoad="onLoad"
          @showPoster="showPosters"
        />
      </div>
    </div>

    <!-- 海报 -->
    <poster
      v-if="showPoster"
      :show="showPoster"
      :posterItem="posterItem"
      @closePoster="closePoster"
      @openShare="openShare"
    />
    <share-mask v-if="showShareMask" @hideMask="hideMask" />

    <!-- 打开app -->
    <!-- <div class="open_app">
      <div class="open_left">甄选品质好货·分享品位生活</div>
      <div class="open_right">打开APP</div>
    </div> -->
  </div>
</template>

<script>
import NativeShare from "nativeshare";
// const Swiper = () => import("./components/Swiper").then(m => m.default || m);
// const Brand = () => import("./components/Brand").then(m => m.default || m);
// const Division = () =>
//   import("./components/Division").then(m => m.default || m);
// const VerticalSwiper = () =>
//   import("./components/VerticalSwiper").then(m => m.default || m);
// const HomeMiddleProduct = () =>
//   import("./components/HomeMiddleProduct").then(m => m.default || m);
// const HomeSwitchBar = () =>
//   import("./components/HomeSwitchBar").then(m => m.default || m);
// const CategoryImg = () =>
//   import("./components/CategoryImg").then(m => m.default || m);
const Recommend = () =>
  import("@/components/Recommend").then((m) => m.default || m);
import StoreDet from "./components/StoreDet";
import ListTitle from "./components/ListTitle";
import ThemeList from "./components/ThemeList";
const ShareMask = () =>
  import("../mine/cardvoucher/components/ShareMask").then(
    (m) => m.default || m
  );
const Poster = () =>
  import("../product/detail/components/Poster").then((m) => m.default || m);
export default {
  components: {
    // Swiper,
    // Brand,
    // Division,
    // VerticalSwiper,
    // HomeMiddleProduct,
    // HomeSwitchBar,
    Recommend,
    StoreDet,
    ListTitle,
    ThemeList,
    ShareMask,
    Poster,
    // CategoryImg
  },
  // watch: {
  //   //监听分享弹窗state
  //   // eslint-disable-next-line no-unused-vars
  //   "$store.state.showShareToast": function(val) {
  //     this.watchShow();
  //   }
  // },
  data() {
    return {
      loadings: false,
      clickIndex: "theme",
      showPoster: false,
      showShareMask: false,
      posterItem: {},
      // bgStyle: {
      //   background: "rgba(255,255,255," + 0 + ")"
      // },
      // opacityStyle: {
      //   opacity: 0.5,
      //   border: "none"
      // },
      // opacityName: {
      //   opacity: 0.5
      // }
    };
  },
  computed: {
    retailHomepage() {
      return this.$store.getters.retailHomepage;
    },
    homeProductList() {
      return this.$store.getters.homeProductList;
    },
    findStoreByCondition() {
      return this.$store.getters.findStoreByCondition;
    },
    getSimpleUserInfo() {
      return this.$store.getters.getSimpleUserInfo;
    },
  },
  created() {
    this.getData();
    this.getAllData();
    this.getStoreData();
    this.getUserData();
  },
  mounted() {
    if (!this.retailHomepage.length) {
      this.clickIndex = "all";
    }
    // window.addEventListener("scroll", this.handleScroll);
    // this.$nextTick(() => {});
  },
  // beforeDestroy() {
  //   window.removeEventListener("scroll", this.handleScroll);
  // },
  methods: {
    // 获取数据
    getData() {
      const params = { slug: this.slug };
      this.$store
        .dispatch("home/retailHomepage", { params })
        .then(() => {})
        .catch(() => {});
    },
    getAllData(pageNo = 1, pageSize = 10) {
      // console.log(1111);
      // findClientRetailSpuByParam
      const params = { pageNo, pageSize, slug: this.slug };
      this.$store
        .dispatch("home/findClientRetailSpuByParam", {
          params,
        })
        .then(() => {
          this.loadings = false;
        })
        .catch(() => {
          this.loadings = false;
        });
    },
    getStoreData() {
      const params = { slug: this.slug, origin: "Front" };
      this.$store
        .dispatch("home/findStoreByCondition", {
          params,
        })
        .then(() => {
          this.loadings = false;
        })
        .catch(() => {
          this.loadings = false;
        });
    },
    // 海报获取用户数据
    getUserData() {
      this.$store
        .dispatch("mine/getSimpleUserInfo")
        .then(() => {})
        .catch(() => {});
    },
    // 刷新
    onRefresh() {
      this.getData();
      // this.getAllData();
      this.getStoreData();
      this.getUserData();
    },
    onLoad() {
      // console.log("上拉进行中");
      // this.loadings = false;
      if (
        this.homeProductList.hasNextPage &&
        this.homeProductList.pageNo <= this.homeProductList.pageCount &&
        !this.loadings
      ) {
        this.loadings = true;
        const pageIndex = this.homeProductList.pageNo + 1;
        this.getAllData(pageIndex);
        // console.log("上拉完毕");
      }
    },
    //tabBar透明度
    // handleScroll() {
    //   let top = document.documentElement.scrollTop || document.body.scrollTop;
    //   let detTo = this.$refs.productDet.offsetTop - 45;
    //   let opacity = top / 500;
    //   opacity = opacity > 1 ? 1 : opacity;
    //   this.bgStyle = { background: "rgba(255,255,255," + opacity + ")" };
    //   this.opacityStyle = { opacity };
    //   if (top < detTo) {
    //     this.opacityStyle = {
    //       opacity: 0.7,
    //       border: "1px solid #fff"
    //     };
    //     this.opacityName = {
    //       opacity: 0.5
    //     };
    //   } else {
    //     this.opacityStyle = {
    //       opacity: 0.3,
    //       border: "1px solid #bf9264"
    //     };
    //     this.opacityName = {
    //       opacity: 1
    //     };
    //   }
    // },
    //搜索
    goSearch() {
      this.$router.push("/search");
    },
    clickTab(value) {
      this.clickIndex = value;
    },
    goMore(id) {
      this.$router.push({
        path: "/home/themelist",
        query: {
          id,
        },
      });
    },
    showPosters(productDetail) {
      this.posterItem = productDetail;
      this.showPoster = true;
    },
    closePoster() {
      this.showPoster = false;
    },
    hideMask() {
      this.showShareMask = false;
    },
    isWechatBrowser() {
      var ua = navigator.userAgent.toLowerCase();
      var isWeixin = ua.indexOf("micromessenger") !== -1;
      return isWeixin;
    },
    openShare() {
      // console.log(typeof NativeShare);
      // console.log(NativeShare, 88888);
      if (typeof NativeShare !== "undefined") {
        // console.log(111);
        if (this.isWechatBrowser()) {
          // console.log(222);
          this.showPoster = false;
          this.showShareMask = true;
        } else {
          this.$toast("需要在微信浏览器分享哦！");
        }
      } else {
        this.showPoster = false;
      }
    },
  },
};
</script>

<style lang="less">
.home {
  // width: 100%;
  // background: #fff;
  // .bra_search1 {
  //   background: #fff;
  // }
  // .bra_search {
  //   position: fixed;
  //   top: 0;
  //   left: 0;
  //   right: 0;
  //   z-index: 100;
  //   width: 100%;
  //   padding: 12px;
  //   box-sizing: border-box;
  //   .input_s {
  //     text-align: left;
  //     background: #fff;
  //     border-radius: 17px;
  //     opacity: 0.5;
  //     border: 1px solid #bf9264;
  //     display: flex;
  //     flex-direction: row;
  //     height: 28px;
  //     box-sizing: border-box;
  //     .search_name {
  //       font-size: 12px;
  //       margin-left: 12px;
  //       margin-top: auto;
  //       margin-bottom: auto;
  //       font-weight: 400;
  //       color: #222;
  //     }

  //     .input_s_1 {
  //       opacity: 0.5;
  //       border: none;
  //       .search_name1 {
  //         opacity: 0.3;
  //       }
  //       margin-top: auto;
  //       margin-bottom: auto;
  //     }
  //     .search_img {
  //       margin-left: 12px;
  //       width: 24px;
  //       margin-top: auto;
  //       margin-bottom: auto;
  //     }
  //   }
  // }
  // 底部商品
  .tar_product {
    margin-bottom: 50px;
  }
  // 轮播图
  // .swiper_list {
  //   width: 100%;
  // }
  // 资讯轮播图
  // .news_title {
  //   width: 36px;
  //   height: 24px;
  //   margin-right: 15px;
  //   display: inline-block;
  // }
  // .icon_right {
  //   width: 24px;
  // }
  // .ver_swiper {
  //   margin: 23px 12px 20px 12px;
  //   border-top: 1px solid rgba(0, 0, 0, 0.06);
  //   border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  //   box-sizing: border-box;
  // }
  .product_bottom {
    margin: 0 12px;
    img {
      display: block;
      box-shadow: 0rem 3px 5px -3px #bbb2a9;
      border-radius: 10px;
      width: 100%;
    }
  }
  // .open_app {
  //   position: fixed;
  //   bottom: 62px;
  //   left: 12px;
  //   right: 12px;
  //   font-size: 14px;
  //   font-weight: 400;
  //   color: #fff;
  //   line-height: 42px;
  //   text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.3);
  //   display: flex;
  //   .open_left {
  //     width: 262px;
  //     height: 42px;
  //     background: linear-gradient(360deg, #000000 0%, #727272 100%);
  //     box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.3);
  //     border-radius: 21px 0px 0px 21px;
  //   }
  //   .open_right {
  //     width: 89px;
  //     height: 42px;
  //     background: linear-gradient(180deg, #fbd692 0%, #e0af65 100%);
  //     box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.3);
  //     border-radius: 0px 21px 21px 0px;
  //   }
  // }
}
</style>
